import { GetTemplates } from 'domain/usecases/get-templates';
import { BaseHttpService } from 'main/factories/http';

export class RemoteGetTemplates extends BaseHttpService<GetTemplates.Model> implements GetTemplates {
  async getAll(params: GetTemplates.Params): Promise<GetTemplates.Model> {
    return await this.request('get', {}, params);
  }
}
